export default "__VITE_ASSET__cEAbSkja__"